
export const setToken = ()=> {

    let token;
    let cookieSelecionado = 'token2=';
    let allCookies = document.cookie.split(';');
    allCookies.forEach(item=>{
        let temp = item.trim();
        if(temp.indexOf(cookieSelecionado)===0){
            token = temp.substring(cookieSelecionado.length,temp.length);
        }
    })

    return token;
}
